import script from "./EditDocumentForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditDocumentForm.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=b9dad638&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9dad638"]])

export default __exports__